var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-header mt-5"},[_c('div',{staticClass:"header-title"},[_c('div',{staticClass:"breadcumb"},[_c('a',{attrs:{"id":"campaign"},on:{"click":_vm.navigteToList}},[_c('i',{staticClass:"fa fa-chevron-left"}),_vm._v(" Campaigns")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }